import { BrawlerStats } from "../../api/brawler-stats/brawler-stats.types";
import { BrawlerBuild } from "./brawler.types";

export const getBrawlerBuild = (brawlerStats: BrawlerStats): BrawlerBuild => {
    const { starPowers, gadgets, gears } = brawlerStats.brawler;
    const starPower = starPowers.slice().sort((a, b) => b.buildStats.number - a.buildStats.number);
    const gadget = gadgets.slice().sort((a, b) => b.buildStats.number - a.buildStats.number);
    const gear = gears.slice().sort((a, b) => b.buildStats.number - a.buildStats.number);
    return {
        starPower: starPower[0].name,
        gadget: gadget[0].name,
        gear1: gear[0].name,
        gear2: gear[1].name
    };
}